<!-- Translated: skip -->
<template>
  <div>
    <div :class="'facts' + (small ? ' small' : '')">
      <div :class="'fact ' + (unit.bedrooms ? 'active' : '')">
        <icon name="antal rum" :scale="1.6" />
        <span>Sovrum ({{unit.bedrooms}}st)</span>
        <span class="hard-fact">x{{unit.bedrooms}}</span>
      </div>
      <div :class="'fact ' + (unit.living_area ? 'active' : '')">
        <icon name="area" :scale="1.6" />
        <span>Boarea ({{unit.living_area}}m<sup>2</sup>)</span>
        <span class="hard-fact">{{unit.living_area}}m<sup>2</sup></span>
      </div>
      <div :class="'fact ' + (unit.internet ? 'active' : '')">
        <icon name="wifi" :scale="1.6" />
        <span>Wi-Fi</span>
      </div>
      <div :class="'fact ' + (unit.washing_machine ? 'active' : '')">
        <icon name="tvattmaskin-black" :scale="1.6" />
        <span>Tvättmaskin</span>
      </div>
      <div :class="'fact ' + (unit.terrace_balcony ? 'active' : '')">
        <icon name="balkong" :scale="1.6" />
        <span>Balkong/altan</span>
      </div>
      <div :class="'fact ' + (unit.dishwasher ? 'active' : '')">
        <icon name="diskmaskin-black" :scale="1.6" />
        <span>Diskmaskin</span>
      </div>
      <div :class="'fact ' + (unit.pets_allowed ? 'active' : '')">
        <icon name="husdjur-black" :scale="1.6" />
        <span>Husdjur tillåtna</span>
      </div>
      <div :class="'fact ' + (unit.sauna ? 'active' : '')">
        <icon name="bastu-black" :scale="1.6" />
        <span>Bastu</span>
      </div>
      <div v-if="!SITE_CONFIG.settings.SettingLockTypes.active" :class="'fact ' + 'active'">
        <icon name="direkt-incheck-black" :scale="1.6" />
        <span>{{ unit.direct_incheck ? SITE_CONFIG.settings.SettingLockTypes.texts[1].title : SITE_CONFIG.settings.SettingLockTypes.texts[0].title }}</span>
      </div>

      <div v-if="SITE_CONFIG.settings.SettingLockTypes.active" :class="'fact ' + (unit.lock_type_id ? 'active' : '')">
        <icon name="direkt-incheck-black" :scale="1.6" />
        {{ unit.lock_type_id ? SITE_CONFIG.settings.SettingLockTypes.texts[unit.lock_type_id].title : Object.values(SITE_CONFIG.settings.SettingLockTypes.texts).map(function (item) {return item.title;}).join(' / ') }}
      </div>

      <div :class="'fact ' + (unit.handicap_rooms ? 'active' : '')">
        <icon name="handikapp" :scale="1.6" />
        <span>Handikappanpassat</span>
      </div>
      <div :class="'fact ' + (unit.dryer_cabinet ? 'active' : '')">
        <icon name="torkskap" :scale="1.6" />
        <span>Torkskåp</span>
      </div>
      <div :class="'fact ' + (unit.toilets ? 'active' : '')">
        <icon name="wc" :scale="1.6" />
        <span>WC ({{unit.toilets}}st)</span>
        <span class="hard-fact">x{{unit.toilets}}</span>
      </div>
      <div v-if="SITE_CONFIG.site != 'branas'" :class="'fact ' + (unit.hot_tub ? 'active' : '')">
        <icon name="badtunna" :scale="1.6" />
        <span>Badtunna</span>
      </div>
      <div :class="'fact ' + (unit.extra_beds ? 'active' : '')">
        <icon name="sangar" :scale="1.6" />
        <span>Extrabäddar ({{unit.extra_beds}}st)</span>
        <span class="hard-fact">x{{unit.extra_beds}}</span>
      </div>
      <div :class="'fact ' + 'active'" v-if="unit.final_cleaning_included && !unit.has_mandatory_cleaning">
        <icon name="stadning-black" :scale="1.6" />
        <span>Slutstäd (ingår)</span>
        <span class="hard-fact">Ingår</span>
      </div>
      <div :class="'fact ' + (unit.final_cleaning_available ? 'active' : '')" v-if="!unit.final_cleaning_included && !unit.has_mandatory_cleaning">
        <icon name="stadning-black" :scale="1.6" />
        <span>Slutstäd (tillval)</span>
        <span class="hard-fact">Tillval</span>
      </div>
      <div :class="'fact ' + (unit.final_cleaning_available ? 'active' : '')" v-if="unit.has_mandatory_cleaning">
        <icon name="stadning-black" :scale="1.6" />
        Slutstäd (obligatoriskt)
      </div>
      <div :class="'fact ' + (unit.child_friendly ? 'active' : '')">
        <icon name="smiley-black" :scale="1.6" />
        <span>Extra barnanpassat</span>
      </div>
      <div :class="'fact ' + (unit.beds ? 'active' : '')">
        <icon name="sangar" :scale="1.6" />
        <span>Bäddar ({{unit.beds}}st)</span>
        <span class="hard-fact">x{{unit.beds}}</span>
      </div>
      <div :class="'fact ' + (unit.fireplace ? 'active' : '')">
        <icon name="kamin-sv" :scale="1.6" />
        <span>Öppen spis</span>
      </div>

      <div :class="'fact ' + (unit.charging_post ? 'active' : '')" v-if="SITE_CONFIG.accomodations.filters.chargeStation">
        <icon name="laddstolpe-black" :scale="1.6" />
        <span>Laddstolpe</span>
      </div>

      <div style="clear:both;"></div>
    </div>
    <a target="_blank" :href="unit.pool.map_link" v-if="!small && unit.pool.map_link" class="button white small border map-bt">
      <icon name="map" :scale="2" /> Se områdeskarta
      <icon name="download" class="dowload-icon" :scale="1.5" />
    </a>
    <div class="facts special-fact" v-if="!small">
      <div class="fact active">
        <icon name="avstand-lift" :scale="1.7" />
        <b>Avstånd pist:</b> {{unit.distance_to_pist}}m
      </div>
      <div class="fact active">
        <icon name="gondol-lift" :scale="1.7" />
        <b>Avstånd lift:</b> {{unit.distance_to_skilift}}m
      </div>

      <div style="clear:both;"></div>
    </div>

    <div class="facts special-fact" v-if="!small && (unit.check_in_time || unit.check_out_time)">
      <div class="fact active" style="width:100%;">
        <b>Incheckning:</b> {{unit.check_in_time}}
      </div>
      <div class="fact active" style="width:100%;padding-top: 0;">
        <b>Utcheckning:</b> {{unit.check_out_time}}
      </div>

      <div style="clear:both;"></div>
    </div>

    <div class="facility-area" v-if="!small && SITE_CONFIG.accomodations.show_site && (unit.facility && unit.facility.id === 2006)">
      <icon name="berget" :scale="2.25" />
      <h4>Berget</h4>
      <p>I Branäsbergets stugor och lägenheter får du en fantastisk utsikt över dalen och närhet till skidåkning, pulkabackar och längdspår. Uppe på berget finns skiduthyrning, shop, livsmedelsbutik och restauranger.</p>
    </div>
    <div class="facility-area" v-if="!small && SITE_CONFIG.accomodations.show_site && (unit.facility && unit.facility.id === 2007)">
      <icon name="byn" :scale="2.25" />
      <h4>Dalen</h4>
      <p>I Branäsdalen finns både lägenheter och större fjällstugor, med nära till allt du behöver. I Branäsdalen har du nära till skiduthyrning, restaurang, shop och en livsmedelsbutik.</p>
    </div>
    <div class="facility-area" v-if="!small && SITE_CONFIG.accomodations.show_site && (unit.facility && unit.facility.id === 2020)">
      <icon name="mattesdalen" :scale="2.25" />
      <h4>Mattesdalen</h4>
      <p>I Mattesdalen finns både lägenheter och större, moderna fjällstugor. Bor du här har du nära till både 4-stolslift och 6-stolslift som snabbt tar dig upp till toppen och resten av skidområdet.</p>
    </div>
  </div>
</template>

<script>
export default {
  props: [
    'unit',
    'small',
  ],
  data() {
    return {
    };
  },
  mounted() {
  },
  computed: {
  },
  methods: {
  },
};
</script>

<style scoped lang="stylus">
@import '~@/global.styl'

.special-fact
  border-radius: 2px;
  background-color: rgba(236, 245, 248, 0.3);
  border: solid 1px #bfd9e1;

.map-bt
  margin-bottom: 20px
  text-align: left
  background-color: #f9fcfd!important;
  color: #dark-blue!important;
  padding-right: 20px;
  padding-top: 10px!important
  padding-bottom: 7px!important
  .icon
    position: relative;
    top: -2px
    margin-right: 5px
  .dowload-icon
    margin-left: 10px


.facts
  max-width 520px
  +max-mobile()
    max-width: 100%
  .fact
    .icon
      margin-right 10px
      opacity 0.2
    color: #cccccc;
    text-decoration:line-through
    font-size: 13px;
    font-weight: 300;
    font-family: Interstate;
    padding: 13px 10px;
    float left
    width 50%
    .hard-fact
      display none
    +max-mobile()
      font-size: 12px
    &:nth-child(4n+3),
    &:nth-child(4n+4)
      background-color: #f9f9f9;
    &.active
      text-decoration:none
      color: #262626;
      .icon
        opacity 1
  &.small
    margin-bottom 0
    font-size: 0.875rem
    .fact
      width auto
      background-color: transparent !important
      padding 0
      margin-right 1rem
      margin-bottom 0.5rem
      display none
      &.active
        display inline-block
        min-width calc(33% - 1rem)
      .icon
        margin-right 0
      span
        // display none
        &.hard-fact
          // display inline

.facts,
.facility-area
  margin-bottom 20px

.facility-area
  border-radius: 2px;
  background-color: rgba(236, 245, 248, 0.3);
  border: solid 1px #bfd9e1;
  padding 21px
  p
    font-size: 14px;
    font-weight: 300;
  .icon
    margin-right 7px
  h4
    united-bold()
    font-size: 15px;
    font-weight: bold;
    letter-spacing: 0.3px;
    color: #262626;
    display inline-block
    text-transform uppercase
</style>



// WEBPACK FOOTER //
// UnitFacts.vue?0c8606f6